// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const INACTIVE_USER = "Neakt\u00edvna";
